<template lang="pug">
div          
        .card-body.bg-light
            .form-row
                .col-md-4
                    label Nombre de Usuario
                    input.form-control.form-control-sm(v-model="parameter.NameUser", @keypress.enter="sendSearch()")
                .col-md-3
                    label Email
                    input.form-control.form-control-sm(v-model="parameter.Email", @keypress.enter="sendSearch()")
                .col-md-3
                    label Estado
                    select.form-control.form-control-sm(v-model="parameter.Active" )
                        option(value=1) Activa
                        option(value=0) Inactiva
                        option(value=2) Todos
                .col-md-2
                    label 
                    button.btn.btn-primary.text-light.btn-block(@click="sendSearch()") Buscar 
                        i.fa.fa-search  
        .card-body.bg-light    
            .form-group.table-responsive
                    table.table.table-sm.table-borderedonlytable
                        thead.bg-table.text-white
                            th Editar 
                            th Nombre de Usuario 
                            th Email
                            th Cargo
                            th Tipo de Cuenta
                            th(v-if="parameter.IdEnterprise==7") Division
                            th Responsable
                            th Estado                        
                        tbody.bg-white(name="table-fade", is="transition-group") 
                            tr(v-if="",v-bind:key="index" v-for="(item,index) in tablaInfo")
                                td
                                    button.btn.btn-sm.btn-info(@click="sendInfo(item)")  
                                        i.fa.fa-edit  
                                    button.btn.btn-sm.btn-warning(@click="sendChangePassword(item)")  
                                        i.fa.fa-key 
                                    button.btn.btn-sm.btn-success(@click="sendInfoAccessDocument(item)")  
                                        i.fa.fa-file-text  
                                    button.btn.btn-sm.btn-primary(@click="sendInfoAccessLink(item)")  
                                        i.fa.fa-external-link  
                                td {{item.NameUser}} 
                                td {{item.Email}}
                                td {{item.Position}}
                                td {{item.TypeAccount}}
                                td(v-if="parameter.IdEnterprise==7") {{ item.DivisionName }}
                                td {{item.IsResponsible==1 ? 'Si':'No'}}
                                td {{item.Active==1 ? 'Activo':'Inactivo'}}

</template>
<script> 
export default {
    props:{
        tablaInfo:Array,
        parameter:Object
    }, 
    methods:{ 
            sendSearch(){ 
                this.$emit("update:parameter",this.parameter) 
                this.$emit("sendSearch",this.parameter) 
            },
            sendInfo(item){  
                console.log(item)
                this.$emit("sendInfo", Object.assign({}, item)) 
            },
             sendInfoAccessDocument(item){  
                console.log(item)
                this.$emit("sendInfoAccessDocument", Object.assign({}, item)) 
            },
            sendInfoAccessLink(item){  
                console.log(item)
                this.$emit("sendInfoAccessLink", Object.assign({}, item)) 
            },
            sendChangePassword(item){  
                this.$emit("sendChangePassword", Object.assign({}, item)) 
            }
    }
}
</script>
<style>
    .table-fade-enter-active {
      transition: all .5s ease;
    }
    .table-fade-leave-active {
      transition: all .5s ease;
    }
    .table-fade-enter, .table-fade-leave-to{
      transform: translateY(-20px);
      opacity: 0;
    } 
</style>